<script setup lang="ts">
import { RouterView } from 'vue-router';
import { ElConfigProvider } from 'element-plus';
// @ts-ignore
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { useCommonStore } from './store';


const commonStore = useCommonStore()



</script>

<template>
    <ElConfigProvider :locale="zhCn"> <!-- 语言 -->
        <RouterView v-if="commonStore.alreadyLoad"></RouterView>
    </ElConfigProvider>


</template>

